/*eslint-disable */
define(function(require) {
    var _ = require('underscore');
    var Backbone = require('backbone');
    var dateFormatter = require('common/util/date');

    var ProfileStoredPayment = Backbone.Model.extend({
        format: function(storedPayments) {

            var cardNames = {
                    'VSA': 'visa',
                    'MAS': 'maestro',
                    'MST': 'mastercard',
                    'AMX': 'amex'
            };

            _.each(storedPayments, function(storedPayment) {
                storedPayment.cardNumber = storedPayment.cardNumber ?
                        storedPayment.cardNumber.slice(storedPayment.cardNumber.length-4,storedPayment.cardNumber.length) :
                        '';
                storedPayment.cardName = cardNames[storedPayment.cardTypeCode];
                storedPayment.formattedExpiryDate = dateFormatter.formatDate('MM/YY', storedPayment.cardExpiryDate);
            });

            return storedPayments;
        }
    });
    return ProfileStoredPayment;
});
